<template>
  <div :class="{
    'form-input': true,
    'form-input--required': data?.required
    }" >
      <label>{{ data?.caption ?? 'Factory' }}
        <img
      v-if="data?.visibility"
      class="mx-1"
      width="15"
      src="~@/assets/images/eye.svg"
      alt="view"
      />
      </label>
      <custom-dropdown :list="filteredFactories" :selected="selectedFactory"
                    :disabled="viewOnly"
                    @select="handleFactorySelection" @toggle="() => factorySearchKeyword = ''"
                    @deselect="handleFactoryDeselection" class="form-template-container-wft">
                    <template #before-items>
                        <div class="fh center py-4" v-if="loadingFactories && factories.length === 0">
                            <loading-circle />
                        </div>
                        <div class="fh center p-3 form-template-container-wft-search-box" v-else>
                            <input type="text p-2" class="form-template-container-wft-input"
                                v-model="factorySearchKeyword" placeholder="Search" />
                        </div>
                    </template>
       </custom-dropdown>
  </div>
</template>

<script>
import { GetAllFactories } from '@/api'
import CustomDropdown from '@/components/common/customDropdown.vue'
import { alert } from '@/plugins/notification'
export default {
  name: 'factoryComponent',
  components: { CustomDropdown },
  computed: {
    filteredFactories () {
      if (this.factorySearchKeyword.trim() === '') {
        return this.factories
      }
      return this.factories.filter(factory =>
        factory.name.toLowerCase().includes(this.factorySearchKeyword.toLowerCase())
      )
    }
  },
  props: {
    mode: {
      type: String,
      default: 'TEMPLATE'
    },
    data: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      componentValue: null,
      factories: [],
      factorySearchKeyword: '',
      loadingFactories: false,
      selectedFactory: null
    }
  },
  watch: {
    value (val) {
      this.componentValue = val
    }
  },
  created () {
    this.loadingFactories = true
    GetAllFactories().then(res => {
      this.factories = res.core_projects
      this.componentValue = this.value
      this.selectedFactory = this.factories.find(factory => factory.id === this.value) || null
    }).catch(() => {
      this.factories = []
      alert('Error fetching factories')
    }).finally(() => {
      this.loadingFactories = false
    })
  },
  methods: {
    emitChange () {
      this.$emit('customChange', {
        field_id: this.$props.data.field_id,
        value: this.componentValue
      })
    },
    handleFactorySelection (factory) {
      this.selectedFactory = factory
      this.componentValue = factory.id
      this.emitChange()
    },
    handleFactoryDeselection () {
      this.selectedFactory = null
      this.componentValue = null
      this.emitChange()
    }
  }
}
</script>

<style lang="scss" scoped >

</style>
